import React from "react";
import "../AMLManagedServices.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { Link } from "react-router-dom";

import {
    FiChevronRight,
    FiShield,
    FiSearch,
    FiAlertTriangle,
    FiDatabase,
    FiFileText,
    FiLock,
    FiCheckCircle,
    FiBarChart2,
    FiTrendingUp,
    FiEye,
    FiRefreshCw
} from "react-icons/fi";


const AMLManagedServices = () => {


    return (

        <>

            <Header />


            <div className="aml-page">


                {/*=====================================================
                            HERO SECTION
                ======================================================*/}


                <section className="aml-hero">


                    <div className="container">


                        <div className="aml-hero-content">


                            <span className="aml-tag">

                                AML MANAGED SERVICES

                            </span>



                            <h1>

                                Advanced Anti-Money Laundering
                                <span> Compliance Solutions</span>

                            </h1>



                            <p>

                                Saivari Fintech delivers comprehensive AML managed
                                services that help financial institutions detect risks,
                                monitor transactions, improve compliance operations,
                                and strengthen financial crime prevention frameworks.

                            </p>



                            <div className="aml-buttons">


                                <a
                                    href="/contact"
                                    className="aml-primary-btn"
                                >

                                    Get Consultation

                                </a>




                                {/* <Link
                                    to="/services"
                                    className="aml-secondary-btn"
                                >

                                    Explore Services

                                </Link> */}


                            </div>



                        </div>


                    </div>


                </section>








                {/*=====================================================
                            BREADCRUMB
                ======================================================*/}



                <section className="aml-breadcrumb">


                    <div className="container">


                        <Link to="/">
                            Home
                        </Link>


                        <FiChevronRight />



                        <Link to="/solutions">
                            Solutions
                        </Link>


                        <FiChevronRight />



                        <span>
                            AML Managed Services
                        </span>


                    </div>


                </section>









                {/*=====================================================
                            AML OVERVIEW
                ======================================================*/}



                <section className="aml-overview">


                    <div className="container">


                        <div className="aml-grid">





                            <div className="aml-content">


                                <span className="section-tag">

                                    OVERVIEW

                                </span>



                                <h2>

                                    Protecting Financial Systems
                                    <span> Against Financial Crime</span>

                                </h2>




                                <p>

                                    Anti-Money Laundering compliance is essential
                                    for banks, NBFCs, payment providers, and fintech
                                    organizations. Our AML managed services provide
                                    continuous monitoring, risk identification,
                                    screening, and reporting support.

                                </p>




                                <p>

                                    We combine regulatory expertise with modern
                                    technology to help organizations detect suspicious
                                    activities, reduce operational risks, and maintain
                                    compliance with financial crime regulations.

                                </p>





                                <div className="aml-checks">


                                    <div>

                                        <FiCheckCircle />

                                        Transaction Monitoring

                                    </div>




                                    <div>

                                        <FiCheckCircle />

                                        Customer Risk Assessment

                                    </div>




                                    <div>

                                        <FiCheckCircle />

                                        Suspicious Activity Reporting

                                    </div>




                                    <div>

                                        <FiCheckCircle />

                                        Regulatory Compliance Support

                                    </div>


                                </div>




                            </div>







                            {/* AML DASHBOARD */}



                            <div className="aml-dashboard">





                                <div className="aml-card">


                                    <FiEye />


                                    <h3>
                                        Monitoring
                                    </h3>


                                    <span>
                                        Real-Time Detection
                                    </span>


                                </div>







                                <div className="aml-card">


                                    <FiShield />


                                    <h3>
                                        Risk Control
                                    </h3>


                                    <span>
                                        Fraud Prevention
                                    </span>


                                </div>







                                <div className="aml-card">


                                    <FiSearch />


                                    <h3>
                                        Screening
                                    </h3>


                                    <span>
                                        Customer Verification
                                    </span>


                                </div>







                                <div className="aml-card">


                                    <FiDatabase />


                                    <h3>
                                        Analytics
                                    </h3>


                                    <span>
                                        Risk Insights
                                    </span>


                                </div>




                            </div>




                        </div>


                    </div>


                </section>









                {/*=====================================================
                        AML CAPABILITIES
                ======================================================*/}



                <section className="aml-capabilities">


                    <div className="container">



                        <div className="section-heading">


                            <span className="section-tag">

                                OUR CAPABILITIES

                            </span>



                            <h2>

                                Complete
                                <span> AML Management Services</span>

                            </h2>



                        </div>







                        <div className="aml-service-grid">





                            <div className="aml-service-card">


                                <div className="aml-icon">
                                    🔍
                                </div>


                                <h3>
                                    Transaction Monitoring
                                </h3>


                                <p>

                                    Monitor transactions continuously to identify
                                    suspicious patterns and financial risks.

                                </p>


                            </div>






                            <div className="aml-service-card">


                                <div className="aml-icon">
                                    👤
                                </div>


                                <h3>
                                    Customer Risk Assessment
                                </h3>


                                <p>

                                    Evaluate customer profiles and assign risk
                                    classifications.

                                </p>


                            </div>






                            <div className="aml-service-card">


                                <div className="aml-icon">
                                    📋
                                </div>


                                <h3>
                                    AML Reporting
                                </h3>


                                <p>

                                    Generate compliance reports and support
                                    regulatory submissions.

                                </p>


                            </div>






                            <div className="aml-service-card">


                                <div className="aml-icon">
                                    🛡
                                </div>


                                <h3>
                                    Sanctions Screening
                                </h3>


                                <p>

                                    Screen customers against watchlists and
                                    regulatory databases.

                                </p>


                            </div>






                            <div className="aml-service-card">


                                <div className="aml-icon">
                                    ⚠️
                                </div>


                                <h3>
                                    Risk Investigation
                                </h3>


                                <p>

                                    Analyze suspicious activities and support
                                    investigation processes.

                                </p>


                            </div>






                            <div className="aml-service-card">


                                <div className="aml-icon">
                                    🔄
                                </div>


                                <h3>
                                    Continuous Monitoring
                                </h3>


                                <p>

                                    Maintain ongoing AML compliance through
                                    proactive monitoring.

                                </p>


                            </div>





                        </div>




                    </div>


                </section>






                <section className="aml-challenges">


                    <div className="container">


                        <div className="section-heading">


                            <span className="section-tag">

                                CHALLENGES WE SOLVE

                            </span>



                            <h2>

                                Reducing
                                <span> Financial Crime Risks</span>

                            </h2>


                        </div>







                        <div className="challenge-grid">





                            <div>


                                <FiAlertTriangle />


                                <h3>
                                    Suspicious Transactions
                                </h3>


                                <p>

                                    Identify unusual transaction behavior
                                    before risks increase.

                                </p>


                            </div>







                            <div>


                                <FiLock />


                                <h3>
                                    Compliance Risk
                                </h3>


                                <p>

                                    Strengthen AML controls and regulatory
                                    readiness.

                                </p>


                            </div>







                            <div>


                                <FiBarChart2 />


                                <h3>
                                    Operational Efficiency
                                </h3>


                                <p>

                                    Improve AML processes through technology
                                    and automation.

                                </p>


                            </div>




                        </div>


                    </div>


                </section>







                <section className="aml-process">


                    <div className="container">



                        <div className="section-heading">


                            <span className="section-tag">

                                AML WORKFLOW

                            </span>



                            <h2>

                                Our AML
                                <span> Management Approach</span>

                            </h2>


                        </div>






                        <div className="aml-process-grid">



                            {
                                [

                                    "Customer Risk Analysis",

                                    "Transaction Monitoring",

                                    "Alert Generation",

                                    "Investigation & Review",

                                    "Reporting",

                                    "Continuous Improvement"


                                ].map((item, index) => (


                                    <div
                                        className="aml-process-card"
                                        key={index}
                                    >


                                        <div className="process-number">

                                            0{index + 1}

                                        </div>


                                        <h3>

                                            {item}

                                        </h3>


                                    </div>



                                ))
                            }



                        </div>




                    </div>


                </section>













                <section className="aml-benefits">


                    <div className="container">



                        <div className="section-heading">


                            <span className="section-tag">

                                BENEFITS

                            </span>



                            <h2>

                                Why Choose Our
                                <span> AML Services</span>

                            </h2>



                        </div>






                        <div className="benefit-grid">





                            <div>

                                <FiShield />

                                <h3>
                                    Better Protection
                                </h3>

                                <p>
                                    Prevent financial crime risks effectively.
                                </p>

                            </div>




                            <div>

                                <FiTrendingUp />

                                <h3>
                                    Improved Compliance
                                </h3>

                                <p>
                                    Maintain regulatory compliance standards.
                                </p>

                            </div>




                            <div>

                                <FiRefreshCw />

                                <h3>
                                    Continuous Monitoring
                                </h3>

                                <p>
                                    Real-time monitoring and risk detection.
                                </p>

                            </div>




                            <div>

                                <FiFileText />

                                <h3>
                                    Accurate Reporting
                                </h3>

                                <p>
                                    Generate reliable compliance reports.
                                </p>

                            </div>



                        </div>




                    </div>


                </section>






            </div>


            <Footer />


        </>

    )

}


export default AMLManagedServices;